// @ts-ignore
import {getImgSrc,getUrlParam} from '@/utils/utils';
import {UserService} from '@digital-supply-chain/module'
import { ApiService, ProductService, UserService as ProUserService } from '@/service';
import { WinForm, UtilService } from '@/libs';

export interface DimensionItem { Name: string; Value: string; DimParamType: string; }
export interface LectotypeItem { ID: number, IsLectotype: boolean, Name: string; ParamType: number, Value: string; }
export interface lectoParamsType {
  DimensionParams: DimensionItem[],
  IsSelected: boolean,
  IsSeries: boolean,
  LectotypeParams: LectotypeItem[],
  ModelFileExt: string;
  ModelFileServerPath: string;
  SkuID: number,
  SkuName: string;
  StepFileServerPath: string;
  StepFileName: string;
}
type productDetailType = {
  ProdID: number;
  ProdName: string;
  CompName: string;
  CompID: number;
  CompMdt: string;
  ProdLogo: string;
  CompLogo: string;
  PromoteName: string,
}
export interface checkParamsItem {
  ItemID: number;
  ItemValue: string;
}

/**
 * 获取下载参数
 * @param savePath 保存地址
 * @param file_ext 文件类型
 * @param lectoParams 选型参数闲情
 * @param productDetail 产品详情
 * @param IsAddToCurrentAssembly 是否将模型插入当前装配体
 * @returns 
 */
export const download = function(savePath: string, file_ext: string, lectoParams: lectoParamsType, productDetail: productDetailType, IsAddToCurrentAssembly = false, lectoProId = 0) {
  const { SkuName, IsSeries, ModelFileExt, ModelFileServerPath, StepFileServerPath, StepFileName } = lectoParams;
  const { ProdName, ProdLogo } = productDetail;
  const ProdID = lectoProId || productDetail.ProdID;
  var option: any = {
    title: "<i>" + SkuName + "</i>" + ProdName,
    logo: getImgSrc(ProdLogo, 50),
    downloadArgs: getDownloadArgs(lectoParams, productDetail, file_ext === 'model_file' ? ModelFileExt : 'step', lectoProId)
  };
  if(file_ext === 'model_file'){
      option.downUrl = `${ApiService.JrzzApi}/${ModelFileServerPath}?token=${encodeURIComponent(UserService.token(false))}&isseries=${IsSeries ? 1 : 0}&skuName=${encodeURIComponent(SkuName)}&HostProdId=${productDetail.ProdID||''}`;
      option.downTo = option.downloadArgs.ModelPath = "\\Model\\" + ProdID + "\\mx.mdprt";
      option.downloadProgress = [`mx_download_progress_${ProdID}`];
      option.downloadComplete = "driveProdModel";
      if(ModelFileExt == "sldasm"){
          savePath = savePath.substring(0, savePath.lastIndexOf(".")) + savePath.substring(savePath.lastIndexOf("\\"));
      }
  } else {
      //如果是纯数字
      if(!StepFileServerPath){
          var downUrl = `${ApiService.JrzzApi}/prod/download/${ProdID}/1?token=${encodeURIComponent(UserService.token(false))}&fileName=${encodeURIComponent(StepFileName)}&skuName=${encodeURIComponent(SkuName)}&HostProdId=${productDetail.ProdID||''}`;
          option.retryInterval = 15;//下载失败后，间隔多少秒后重试，false时不做重试
          option.existUrl = `${ApiService.JrzzApi}/prod/download/exist/${ProdID}/1?fileName=${encodeURIComponent(StepFileName)}`;
      }else{
          var downUrl =  `${ApiService.JrzzApi}/${StepFileServerPath}?token=${encodeURIComponent(UserService.token(false))}&fileName=${encodeURIComponent(StepFileName)}&skuName=${encodeURIComponent(SkuName)}&HostProdId=${productDetail.ProdID||''}`;
      }
      option.downUrl = downUrl;
      option.downTo = option.downloadArgs.ModelPath = `\\Model\\${ProdID}\\Step\\${ProdID}.mdstp`;
      option.downloadProgress = [`step_download_progress_${ProdID}`];
      option.downloadComplete = "openStepModel";
  }
  option.saveTo = option.downloadArgs.SavePath = savePath;
  option.downloadArgs.IsAddToCurrentAssembly = IsAddToCurrentAssembly;
  return option;
}

/**
 * 组装下载相关参数（用于客户端驱动模型使用）
 * @param lectoParams 选型参数
 * @param productDetail 产品详情
 * @returns 
 */
export const getDownloadArgs = function(lectoParams: lectoParamsType, productDetail: productDetailType, file_ext: string, lectoProId = 0) {
  const { SkuName, LectotypeParams, DimensionParams } = lectoParams;
  const { ProdName, CompName, CompID, CompMdt } = productDetail;
  const ProdID = lectoProId || productDetail.ProdID;
  var args =  {
    ProdID: `${ProdID}`, 
    SkuName: SkuName, 
    DrawName: ProdName + " " + SkuName,
    SkuJoinName: 'm_'+ ProdID + LectotypeParams.filter((x: LectotypeItem)=>x.IsLectotype).map((x: LectotypeItem)=>x.Value).join("_"),
    FileExt: file_ext,
    ProdName, 
    CompName: CompName || '', 
    CompID: `${CompID}`,
    CompMdt: CompMdt || '',
    DimensionParams: DimensionParams.map(function(item: DimensionItem){
                      return {
                        N: item.Name || '',
                        V: item.Value || '',
                        T: item.DimParamType || ''
                      }
                    }), 
    LectoParams: LectotypeParams.map(function(item: LectotypeItem){
                  return {
                    N: item.Name || '',
                    V: item.Value || '',
                  }
                })
  }
  var fixed = [{"N": "设计软件","V":"今日制造"}];
  args.CompName && (fixed.push({"N": "生产厂家","V": args.CompName}));
  args.LectoParams = fixed.concat(args.LectoParams).concat([{"N":"名称","V": args.DrawName},{"N":"规格","V":args.SkuName}]);
  return args;
}

/**
 * 获取或者选择文件下载路径
 */
export const getSavePath = async function(file_name: string, file_ext: string) {
  var path = WinForm.md.saveFileDlg("模型文件（*." + file_ext + "）|*." + file_ext, "", file_name + "." + file_ext);
  if(path !=="failed") {
    return path;
  } else {
    return;
  }
}

/**
 * 模型下载时是询问还是固定选择  1 or 2
 * @param CompId 
 * @returns 
 */
export const getModelSaveType = function(CompId: number): { key: 'modelSaveType' | 'modelWgjSaveType', saveType: 1 | 2, savePath: string } {
  const configKey = `sjb_config_${UserService.user().UserID}`;
  const config = WinForm.storge.get(configKey) || {};
  if (Number(CompId) === 0) {
    // 标准件
    return { key: 'modelSaveType', saveType: config.modelSaveType || 1, savePath: config.modelSavePath || '' };
  }
  // 外购件
  return { key: 'modelWgjSaveType', saveType: config.modelWgjSaveType || 1, savePath: config.modelWgjSavePath || '' };
}

/**
 * 格式化标准件的名称
 * @param skuName 
 * @param lectoParams 
 * @returns 
 */
export const formatBzjName = function(ProdName: string, PromoteName: string, skuName: string, lectoParams: any): string {
  console.log(arguments);
  //格式化标准件的名称
  const configKey = `sjb_config_${UserService.user().UserID}`;
  const config = WinForm.storge.get(configKey) || {};
  let config_model_name = (config && config.modelNameRole) || "标准[名称规格]";
  //替换标准、名称、规格等先替换为占位符，目的是为了后期取消替换名称存在混乱的可能性
  config_model_name = config_model_name.replace("标准", "$1").replace("规格", "$2").replace("名称", "$3");
  for(var i=0;i<lectoParams.length;i++) {
      var param = lectoParams[i];
      config_model_name = config_model_name.replace(param.Name, "$" + (i + 4));
  }
  //正式替换
  config_model_name = config_model_name.replace("$1", PromoteName).replace("$2", skuName).replace("$3", ProdName);
  for(var i=0;i<lectoParams.length;i++) {
      config_model_name = config_model_name.replace("$" + (i + 4), lectoParams[i].Value);
  }
  config_model_name = config_model_name.replace("物料号", "$物料号");
  return UtilService.SpecialCharacter(config_model_name);
}

/**
 * 检测是否可下载
 * @returns 
 */
export const downloadCheckFun = async function(CompID: number, ProdID: number) {
  var check = true;
  const userInfo = UserService.user();
  if (userInfo.CompID == 0 || userInfo.CompID != CompID){
    try {
      const res = await ProductService.downloadCheck(ProdID);
    } catch (error) {
      check = false;
    }
  }
  return check;
}

export const defaultLectoParamsByKey = function(defaultCheckParams: any, lectoParams: lectoParamsType) {
  return new Promise(resolve => {
    let checkParams: any = defaultCheckParams;
    const lecto_value_key = getUrlParam('lecto_value_key') || "";
    if (!lecto_value_key) {
      resolve(checkParams);
      return false;
    }
    ProUserService.getData(lecto_value_key).then((res) => {
      if (res.data) {
        let lectos = [];
        try {
          lectos = JSON.parse(res.data) || [];
        } catch (error) {}
        if (lectos.lecto_params) {
          lectos = lectos.lecto_params;
        }
        lectos.forEach((item: any) => {
          let findOne = null;
          if (item.ItemID) {
            findOne = lectoParams.LectotypeParams.find(v => v.ID === item.ItemID);
          } else {
            findOne = lectoParams.LectotypeParams.find(v => v.Name === item.ItemName);
          }
          findOne && (checkParams[findOne.ID] = { ItemID: findOne.ID, ItemName: item.ItemName, ItemValue: item.ItemValue })
        })
        resolve(checkParams);
      } else {
        resolve(checkParams);
      }
    }).catch(() => { resolve(checkParams); })
  })
}

/**
 * 通过地址栏参数获取默认选型参数
 * @param lectoParams 选型参数
 * @returns 
 */
export const defaultLectoParams = function(defaultCheckParams: any, lectoParams: lectoParamsType){
  let checkParams: any = defaultCheckParams;
  var lectos = [];
  try {
    lectos = JSON.parse(getUrlParam('lecto_params')) || [];
  } catch (error) {}
  if (lectos.length <= 0) return checkParams;
  lectos.forEach((item: any) => {
    let findOne = null;
    if (item.id) {
      findOne = lectoParams.LectotypeParams.find(v => v.ID === item.id);
    } else {
      findOne = lectoParams.LectotypeParams.find(v => v.Name === item.name);
    }
    findOne && (checkParams[findOne.ID] = { ItemID: findOne.ID, ItemName: item.name, ItemValue: item.value })
  })
  return checkParams;
}

/**
 * 返回组合后的型号收藏需要的参数
 * @param productDetail 
 * @param lectoParams 
 * @param checkParams 
 * @returns 
 */
export const getLectoFavoriteParams = function(productDetail: productDetailType, lectoParams: lectoParamsType, checkParams: checkParamsItem) {
  const {ProdName} = productDetail;
  let FileName = UtilService.SpecialCharacter(`${ProdName}[${lectoParams.SkuName}]`);
  const NationalMarkObj = lectoParams.LectotypeParams.find(item => item.Name === '国标号');
  const data = JSON.stringify({
    SkuName: lectoParams.SkuName,
    FileName,
    LectoParams: Object.values(checkParams),
    NationalMark: NationalMarkObj?.Value || '',
  });
  return {
    data,
    md5: WinForm.md.getMD5Hash(data),
  }
}


export const getStandardData = function(prodJsonParams = '') {
  let prodJsonParamsArr = [];
  try {
    prodJsonParamsArr = JSON.parse(prodJsonParams);
  } catch (error) {}
  // 标准件产品属性
  const names = ['product_type','standard_id', 'standard_name'];
  const standards = prodJsonParamsArr.filter((item: { ProName: string; ProValue: string; }) => (names.includes(item.ProName)));
  let obj: any = {};
  standards.forEach((item: { ProName: string | number; ProValue: any; }) => {
    obj[item.ProName] = item.ProValue;
  })
  return obj;
}
